<template>
  <div class="HistoryListPage">
    <NavTabs
        :items="navList.list"
        :active-index="navList.nowSelectedNo"
        @change="changeNav"
    />
    <div class="historyList">
      <!-- 列表 -->
      <div class="list">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="van-pull-refresh">
          <van-list
              class="dataList"
              v-model="loading"
              :finished="finished"
              @load="onLoad"
              v-if="dataList.length > 0"
              offset="300"
          >
            <div
                class="itemBox"
                v-for="(value, key) in dataList"
                :key="key"
            >
              <CouponItem
                  :coupon="value"
                  :status="status"
                  :show-action-button="status == 2 && shouldShowHistoryButton(value)"
                  action-button-text="查看账单"
                  @use-coupon="() => buttonOnClick(value)"
              />
            </div>
          </van-list>
          <!-- 没有数据 -->
          <div class="noData" v-else-if="!loading">
            <img
                src="../../assets/icon_no_coupon.png"
                alt=""
            />
            <p>无优惠券</p>
          </div>
        </van-pull-refresh>
      </div>
    </div>
    <!-- loading组件 -->
    <transition name="fade">
      <loading v-show="loading"></loading>
    </transition>
  </div>
</template>

<script>
import {personalCoupon} from "../../api/HttpService";
import CouponItem from "../../components/CouponItem/CouponItem.vue";
import NavTabs from "@/components/NavTabs/NavTabs.vue";
import Loading from "@/components/loading/loading.vue";

export default {
  name: "HistoryListPage",
  mounted: function () {
    document.title = "历史记录";
    if (this.$route.query.kind){
      this.kind = this.$route.query.kind.toString();
    }
    this.personalCoupon()
  },
  components: {
    Loading,
    NavTabs,
    CouponItem,
  },
  data: function () {
    return {
      navList: {
        nowSelectedNo: 0,
        list: ["已使用", "已过期"],
      },
      navBottomLine: {
        left: "0px",
        width: "0px",
      },
      loading: false,
      //列表数据
      dataList: [],
      refreshing: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      //传入的kind,查询该kind下的历史券
      kind: 10,
      //状态
      status: 2,

    };
  },
  methods: {
    //   点击顶部nav
    changeNav: async function (key) {
      if (this.navList.nowSelectedNo == key) {
        // 如果key 没有变化，那么什么都不做
      } else {
        // 否则
        switch (key) {
          case 0:
            this.status = 2;
            break;
          case 1:
            this.status = 4;
            break;
        }
        this.navList.nowSelectedNo = key;
        this.dataList = [];
        this.pageNum = 1;
        this.finished = false;
        this.loading = false;
        await this.personalCoupon();
      }
    },
    // 获取数据
    personalCoupon: async function () {
      this.loading = true;
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        kind: this.kind,
        status: this.status,
        classes: 10,
      };
      await personalCoupon(params)
          .then(({res}) => {
            // 如果没有下一页了
            if(res.originalData.code == "SUCCESS" && res.originalData.bizCode == "SUCCESS"){
              if (res.data.pageNum >= res.data.pages) {
                console.log("是否还有下一页")
                this.finished = true;
              } else {
                this.finished = false;
              }
              this.dataList.push(...res.data.data)
              this.pageNum++;
            } else{
              this.$toast(res.originalData.bizMsg || "网络异常")
              this.finished = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.$toast("网络异常");
            this.finished = true;
          });
      this.loading = false;
    },
    onLoad: async function () {
      console.log("加载下一页");
      await this.personalCoupon();
    },
    // list刷新
    onRefresh: async function () {
      console.log("开始刷新");
      this.dataList = [];
      this.pageNum = 1;
      this.finished = false;
      this.loading = false;
      this.refreshing = true;
      await this.personalCoupon();
      this.refreshing = false;
    },
    // 右侧button的点击事件
    buttonOnClick: function (value) {
      this.saveTabType();
      switch (value.kind) {
        case 10://公交订单
          window.location.href = process.env.VUE_APP_DXLCBILL_URL + "#/BillDetailPage?couponNo=" + value.recordNo;
          break
        case 20://定制公交订单
          window.location.href = "liangla://msg/cstmbusOrder?couponNo="+value.recordNo;
          break
        case 30://国联行
          window.location.href = process.env.VUE_APP_GLX_URL;
          break
        case 80://话费充值
          window.location.href = process.env.VUE_APP_RECHARGE_URL+"?orderNo="+value.orderId;
          break
      }
    },
    // 保存kind
    saveTabType(){
      this.$router.replace({
        name: "HistoryListPage",
        query: {
          kind: this.kind,
        },
      });
    },
    // 判断是否显示右侧查看历史账单button
    shouldShowHistoryButton: function (coupon) {
      return coupon && (coupon.kind == 10 || coupon.kind == 20 || coupon.kind == 30 || coupon.kind == 80);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../page/HistoryListPage/HistoryListPage.scss";
</style>
